import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	feeds: [],
	feedsMeta: {},
	lastFeedPage: null,
	lastScrolling: 0,
	postLikedUsers: [],
	lastcursor: null,
	currentCusror: 0,
	myFeeds: [],
};

const feedsStore = (set: any) => ({
	...initialState,

	setFeeds: (data: any) => set((state: any) => ({ ...state, feeds: data })),
	setFeedsMeta: (data: any) => set((state: any) => ({ ...state, feedsMeta: data })),
	setLastFeedPage: (data: any) => set((state: any) => ({ ...state, lastFeedPage: data })),
	setLastScrolling: (data: any) => set((state: any) => ({ ...state, lastScrolling: data })),
	setLastcursor: (data: number) => set((state: any) => ({ ...state, lastcursor: data })),
	setCurrentCursor: (data: number) => set((state: any) => ({ ...state, currentCusror: data })),
	setMyFeeds: (data: any) => set((state: any) => ({ ...state, myFeeds: data })),

	updateIsLike: (postId: string | number, isLike: boolean) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) => (feed.postId === postId ? { ...feed, isLike } : feed)),
		})),

	updateTotalLikes: (postId: number, totalLikes: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, totalLikes } : feed,
			),
		})),

	updateTotalComments: (postId: number, totalComments: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, totalComments } : feed,
			),
		})),

	updateIsConnected: (postId: number, isConnected: number) =>
		set((state: any) => ({
			feeds: state.feeds.map((feed: any) =>
				feed.postId === postId ? { ...feed, isConnected } : feed,
			),
		})),

	setPostLikedUsers: (data: any) =>
		set(() => ({
			postLikedUsers: Array.isArray(data) ? data : [],
		})),

	removeFeedByPostId: (postId: number) =>
		set((state: any) => ({
			feeds: state.feeds.filter((feed: any) => feed.postId !== postId),
		})),

	removeFeedByUserId: (userId: number) =>
		set((state: any) => ({
			feeds: state.feeds.filter((feed: any) => feed.userId !== userId),
		})),

	resetFeeds: () => set({ ...initialState }),
});

const useFeedsStore = create(devtools(feedsStore));

export const {
	setFeeds,
	setFeedsMeta,
	setLastFeedPage,
	setLastScrolling,
	updateIsLike,
	updateTotalLikes,
	updateTotalComments,
	updateIsConnected,
	setPostLikedUsers,
	removeFeedByPostId,
	removeFeedByUserId,
	resetFeeds,
	setLastcursor,
	setCurrentCursor,
	setMyFeeds,
} = useFeedsStore.getState();

export default useFeedsStore;
